var map = {
	"./1.svg": 1218,
	"./10.svg": 1219,
	"./11.svg": 1220,
	"./12.svg": 1221,
	"./2.svg": 1222,
	"./3.svg": 1223,
	"./4.svg": 1224,
	"./5.svg": 1225,
	"./6.svg": 1226,
	"./7.svg": 1227,
	"./8.svg": 1228,
	"./9.svg": 1229,
	"./avatar-1.jpg": 842,
	"./avatar-2.jpg": 843,
	"./avatar-3.jpg": 844,
	"./avatar-4.jpg": 845,
	"./avatar-5.jpg": 1230,
	"./backgroundSvg.zip": 1231,
	"./bg.png": 1232,
	"./logo.png": 161,
	"./new.svg": 1233
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 841;